import { render, staticRenderFns } from "./GeneralError.vue?vue&type=template&id=6aed04ee&scoped=true&"
import script from "./GeneralError.vue?vue&type=script&lang=js&"
export * from "./GeneralError.vue?vue&type=script&lang=js&"
import style0 from "./GeneralError.vue?vue&type=style&index=0&id=6aed04ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aed04ee",
  null
  
)

export default component.exports